/* eslint-disable import-x/no-default-export */
// @ts-ignore
import Chance from 'chance';

const chance = new Chance();

export default () => {
  const skill = chance.pickone([
    'Excel',
    'HTML',
    'CSS',
    'Javascript',
    'Haskell',
    'Ruby',
    'React',
    'Python',
    'GraphQL',
    'SQL',
    'jQuery',
    'UX design',
    'UI design',
    'Crime fighting',
    'AWS',
    'ClickOps',
    'Deploying on Friday',
    'Using 1 letter variable names',
    'Wasting time',
    'Making coffee',
    'Taking 3 hour lunches',
    'Causing segfaults',
    'Testing in production',
    'Exposing secrets',
    'Using tabs instead of spaces',
  ]);
  return {
    keyword: {
      text: skill,
      ontologyId: chance.url({ domain: 'graph.seek.com' }),
    },
  };
};
